export const CATALOG_SLUG = "preview-catalog";
export const ESHOP_STORE_TYPE = "Spree::EshopStore";

export const SHOP_NUMBER_REGEX = /S\d{9}/;

export const DEFAULT_BYO_SHOP_CODE = "create-my-own-byo";
export const DEFAULT_GIFT_SHOP_CODE = "stadium-gift-shop";
